import { useState, useEffect, useRef, useCallback, act, useMemo } from "react";
import { IoMdClose } from "react-icons/io";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { BsPencil } from "react-icons/bs";
import { BsCheck2 } from "react-icons/bs";
import { RiUserAddLine } from "react-icons/ri";
import { PiCaretDownLight } from "react-icons/pi";
import { IoCheckmarkOutline } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { IoIosLink } from "react-icons/io";
import { CiGlobe } from "react-icons/ci";
import Modal from "../../../../Components/Modals/Modall";
import { deleteApiCaller, postApiCaller } from "../../../../Libs/apiCaller";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoTrash } from "react-icons/go";
import { Menu } from "@headlessui/react";
import profile_ImgChannel from "../../../../Assets/Images/multipleUsers.png";
import profile_ImgUser from "../../../../Assets/Images/user.png";

export default function ContactInfo({
  settings,
  setSettings,
  selectedUser,
  setSelectedUser,
  setIsViewing,
  setActiveSection,
  allUser,
  setActiveChannel,
  updateChannel,
  activeChannel,
  setShowProfileView,
  toggleAddGroupMember,
  setShowEditChannel, // 👈 Add this
  fetchChannels,
  setChannels,
  setAllMessages,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [chatColor, setChatColor] = useState("#7104F8"); // default blue
  const [bgColor, setBgColor] = useState("#f3f4f6"); // default gray
  const [image, setImage] = useState(profile_ImgChannel); // Default image
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [groupName, setGroupName] = useState("The Daily Buzz");
  const [description, setDescription] = useState(
    "Welcome to our channel! Here, we explore a variety of topics, from technology trends to lifestyle tips. Join us for engaging discussions and insightful content!"
  );
  const [isOpen, setIsOpen] = useState({});
  const dropdownRef = useRef(null); // Create a reference for the dropdown
  const caretRef = useRef(null); // Create a reference for the caret icon
  const [channelName, setChannelName] = useState("Public channel");
  const [timeoutId, setTImeoutId] = useState(null);
  const [isfollowLoading, setIsFollowLoading] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [isEditingError, setIsEditingError] = useState("");
  let uid = localStorage.getItem("userId");

  useEffect(() => {
    setTimeout(() => {
      setShowNotif(true);
    }, 50);
  }, []);

  useEffect(() => {
    if (settings) {
      setChatColor(settings.chatColor);
      setBgColor(settings.background);
      setIsMuted(settings.muteNotification);
    }
  }, [settings]);

  useEffect(() => {
    if (activeChannel) {
      setGroupName(activeChannel.channelName);
      setDescription(activeChannel.description);
      setImage(activeChannel?.mediaId?.imageUrl || image); // Set the image URL from the channel data
    }
  }, [activeChannel]);

  const saveChannelName = () => {
    setIsEditingName(false);
    // Optionally: send updated name to backend here
  };

  const saveChannelDescription = () => {
    setIsEditingDescription(false);
    // Optionally: send updated description to backend here
  };
  // Toggle menu on caret click
  const toggleMenu = (id) => {
    setIsOpen((prev) => {
      const isCurrentlyOpen = prev[id];
      // Reset and only toggle the clicked id
      return { [id]: !isCurrentlyOpen };
    });
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        caretRef.current &&
        !caretRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    // Add event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNameChange = (e) => {
    setGroupName(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const toggleEditMode = (type) => {
    setGroupName(activeChannel.channelName);
    setDescription(activeChannel.description);
    if (type === "name") {
      setIsEditingName(!isEditingName);
    } else {
      setIsEditingDescription(!isEditingDescription);
    }
  };

  const saveChannel = async (type) => {
    const data = {};
    if (type === "name") {
      if (groupName.trim() === "") {
        setIsEditingError("Group Name cannot be empty");
        return;
      }
      setIsEditingName(false);
      if (groupName !== activeChannel.channelName) {
        data.channelName = groupName;
      }
      if (data.channelName) {
        await updateChannel(data);
        fetchChannels(true);
        // window.location.reload(); // Reload the page to reflect changes
      }
    } else {
      setIsEditingDescription(false);
      if (description === activeChannel.description) {
        return;
      }
      data.description = description;
      await updateChannel(data);
      fetchChannels(true);
    }
    setIsEditingError("");
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 10 * 1024 * 1024) {
      toast.error("Image size should be less than 10MB");
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const formData = new FormData();
        formData.append("messageMedia", file);
        updateChannel(formData, { mediaId: { imageUrl: reader.result } });
        setImage(reader.result); // Set the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  const isAdmin = useMemo(() => {
    if (!activeChannel) return [];
    return activeChannel.adminId.some((ele) => ele._id == uid);
  }, [activeChannel]);

  const isFollowing = useMemo(() => {
    if (!activeChannel) return [];
    return activeChannel.users.some((ele) => ele._id == uid);
  }, [activeChannel]);

  const handleSettingsChange = async (
    chtColor = chatColor,
    bgClr = bgColor,
    isMtd = isMuted
  ) => {
    const endpoint = `setting/add`;
    postApiCaller(endpoint, {
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
      channelId: activeChannel._id,
    });

    setSettings({
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
    });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(
      `${process.env.REACT_APP_PUBLIC_FRONT_END_URL}/channels/${activeChannel.slug}`
    );
    toast.success("Link copied to clipboard!");
  };

  const deleteChannel = async () => {
    const endpoint = `channel/delete/${activeChannel._id}`;
    const response = await deleteApiCaller(endpoint);
    if (response?.status === 200) {
      toast.success("Channel deleted successfully");
      setChannels((prev) => prev.filter((ele) => ele._id != activeChannel._id));
      setActiveChannel(null);
      setAllMessages([]);
      setShowProfileView(false);
      setDeleteModal(false);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const removeUser = async () => {
    if (!selectedUser) {
      setRemoveModal(false);
      return;
    }
    const endpoint = `channel/${activeChannel._id}/remove-user/${selectedUser._id}`;
    const response = await deleteApiCaller(endpoint);
    if (response?.status === 200) {
      setRemoveModal(false);
      fetchChannels(true);
      setActiveChannel((prev) => {
        prev.users = prev.users.filter((ele) => ele._id != selectedUser?._id);
        return prev;
      });
      toast.success("User removed successfully");
      setSelectedUser(null);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const toggleFollowing = async () => {
    setIsFollowLoading(true);
    if (isFollowing) {
      const endpoint = `channel/leave/${activeChannel._id}`;
      const response = await deleteApiCaller(endpoint);
      if (response?.status === 200) {
        setActiveChannel((prev) => {
          const updatedUsers = prev.users.filter((user) => user._id !== uid);
          return { ...prev, users: updatedUsers };
        });
        toast.success("Channel unfollowed successfully");
        fetchChannels(true);
      } else {
        toast.error(response?.response?.data?.message || response.message);
      }
    } else {
      const endPoint = `channel/subscribe/${activeChannel._id}`;
      const response = await postApiCaller(endPoint, {});
      if (response?.status === 200) {
        setActiveChannel((prev) => {
          const updatedUsers = [...prev.users, userInfo];
          return { ...prev, users: updatedUsers };
        });
        toast.success("Channel followed successfully");
        fetchChannels(true);
        // window.location.reload();
      } else {
        toast.error(response?.response?.data?.message || response?.message);
      }
    }
    setIsFollowLoading(false);
  };

  const createChat = async (createChatId) => {
    const endPoint = "chat/create";
    const response = await postApiCaller(endPoint, { user: createChatId });
    if (response?.status === 200) {
      navigate("/home", {
        state: { chat: response.data.data },
      });
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        // Close all menus by resetting isOpen
        toggleMenu(null); // or however you close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleMenu]);

  const sortUsers = useMemo(() => {
    if (!activeChannel?.users || !activeChannel?.adminId) return [];
    const adminUsers = activeChannel.users.filter((user) =>
      activeChannel.adminId.some((admin) => admin._id === user._id)
    );

    const nonAdminUsers = activeChannel.users
      .filter(
        (user) => !activeChannel.adminId.some((admin) => admin._id === user._id)
      )
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    return [...adminUsers, ...nonAdminUsers];
  }, [activeChannel]);

  return (
    <>
      <div className="h-full bg-white">
        <div className="sticky w-full min-h-[67px] py-3.5 bg-white flex items-center justify-between border-b  text-black p-4 text-center">
          <div className="">
            <div className="w-full items-center bg-white text-black flex gap-4 ">
              <IoMdClose
                onClick={() => setShowProfileView(false)}
                className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
              />
              <h1 className="text-lg font-semibold text-center ">
                Channel Info
              </h1>
            </div>
          </div>
        </div>
        <div className="bg-[#f9f6fe] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
          <div className="bg-white pb-4 rounded-b-lg">
            <div className="profile-section p-4 pt-6 rounded-xl max-w-md flex flex-col justify-center items-center gap-4 text-center">
              <div className="avatar">
                <div className="relative">
                  <div className="w-[160px] h-[160px] rounded-full overflow-hidden">
                    <img
                      src={image || profile_ImgChannel}
                      alt="Group"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {isAdmin && (
                    <>
                      <label
                        htmlFor="channel-file-upload"
                        className="bg-[var(--primary-color)] absolute top-0 right-4 w-fit rounded-full p-2 cursor-pointer hover:opacity-50 z-30"
                      >
                        <BsPencil className="text-white text-xl" />
                      </label>
                      <input
                        type="file"
                        id="channel-file-upload"
                        name="channel-file-upload"
                        accept=".jpg,.png"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />
                    </>
                  )}
                </div>
              </div>

              <div>
                <div className="flex items-center z-10 gap-2">
                  {isEditingName ? (
                    <div className="relative flex flex-col items-center gap-2">
                      <input
                        maxLength={30}
                        type="text"
                        value={groupName}
                        onChange={handleNameChange}
                        className="relative text-md font-semibold text-black p-2 px-4 pr-10 border w-80 rounded-lg border-gray-300 focus:outline-none"
                      />
                      {isEditingError && (
                        <p className="text-red-500 text-sm">{isEditingError}</p>
                      )}
                      <BsCheck2
                        className="absolute right-3 top-2.5 text-black text-xl cursor-pointer"
                        onClick={() => saveChannel("name")}
                      />
                    </div>
                  ) : (
                    <h2 className="text-lg font-semibold text-black pt-1 truncate max-w-xs">
                      {groupName}
                    </h2>
                  )}
                  {isAdmin && !isEditingName && (
                    <BsPencil
                      className="cursor-pointer transform text-[var(--primary-color)]"
                      onClick={() => toggleEditMode("name")}
                    />
                  )}
                </div>
                <div className="flex pt-2 items-center gap-2 text-sm text-base-content opacity-70">
                  <span className="text-black text-center flex justify-center mx-auto font-normal">
                    {activeChannel?.users?.length} Follower
                    {activeChannel?.users?.length > 1 && "s"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-1 bg-white pb-4 rounded-lg p-4">
            <div className="flex gap-3 justify-around items-center">
              {!isAdmin && (
                <div
                  onClick={() => setIsFollowLoading(true)}
                  className="flex flex-col items-center gap-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                >
                  <IoCheckmarkOutline className="text-[#7104f8]" size={24} />
                  <span className="text-sm text-black font-semibold">
                    {isFollowing ? "Following" : "Follow"}
                  </span>
                </div>
              )}
              {activeChannel?.isPublic && (
                <>
                  <div
                    onClick={() => {
                      navigate("/home", {
                        state: {
                          url: `${process.env.REACT_APP_PUBLIC_FRONT_END_URL}/channels/${activeChannel?.slug}`,
                          name: activeChannel?.channelName,
                          description: activeChannel?.description,
                        },
                      });
                    }}
                    className="flex flex-col text-black items-center gap-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                  >
                    <PiShareFatLight className="text-black" size={24} />
                    <span className="text-sm text-black font-semibold">
                      Forward
                    </span>
                  </div>
                  <div
                    onClick={(ev) => handleCopy()}
                    className="flex flex-col items-center gap-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                  >
                    <IoIosLink className="text-black" size={24} />
                    <span className="text-sm text-black font-semibold">
                      Copy Link
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="my-1 bg-white pb-4 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                About Channel
              </h3>
              {isAdmin && !isEditingDescription && (
                <BsPencil
                  className="cursor-pointer transform text-[var(--primary-color)]"
                  onClick={() => toggleEditMode("description")}
                />
              )}
            </div>
            {isEditingDescription ? (
              <div className="relative flex flex-col gap-2">
                <textarea
                  value={description}
                  onChange={handleDescriptionChange}
                  rows={3}
                  className="text-[15px] font-semibold pr-8 text-black p-2 px-4 border w-96 mt-3 rounded-lg border-gray-300 focus:outline-none resize-none"
                />
                <div className="absolute top-5 right-2">
                  <BsCheck2
                    className="text-black text-xl cursor-pointer"
                    onClick={() => saveChannel("description")}
                  />
                </div>
              </div>
            ) : (
              <p className="text-[15px] text-black font-semibold mt-2 whitespace-pre-wrap">
                {description}
              </p>
            )}
          </div>
          {/* 
          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                Media, Links & Documents
              </h3>
              <div onClick={() => setActiveSection("media")}>
                <h3 className="hover:underline cursor-pointer hover:text-[var(--primary-color)] text-sm flex items-center gap-1 font-normal text-[#7C7C7C] mb-1">
                  254{" "}
                  <MdArrowForwardIos className="group-hover:text-[var(--primary-color)]" />
                </h3>
              </div>
            </div>

            <div className="flex gap-3 mt-2">
              {[m1, m2, m3, m4].map((url, index) => (
                <div
                  key={index}
                  className="min-w-[90px] min-h-[80px] rounded-xl overflow-hidden"
                >
                  <img
                    src={url}
                    alt={`media-${index}`}
                    className="h-[80px] w-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div> */}

          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4">
            {/* Mute Notification */}
            <div className="flex justify-between items-center">
              <div>
                <p className=" flex items-center gap-2 text-black font-semibold">
                  <HiOutlineSpeakerWave className="text-xl" /> Mute
                  Notifications
                </p>
              </div>
              <div>
                <label for="toggle" class="flex items-center cursor-pointer">
                  <input
                    checked={isMuted}
                    onChange={(ev) => {
                      setIsMuted(ev.target.checked);
                      if (timeoutId) {
                        clearTimeout(timeoutId);
                      }
                      setTImeoutId(
                        setTimeout(() => {
                          handleSettingsChange(
                            chatColor,
                            bgColor,
                            ev.target.checked
                          );
                        }, 500)
                      );
                    }}
                    type="checkbox"
                    id="toggle"
                    class="sr-only peer"
                  />
                  <div
                    className={`${
                      showNotif ? "block" : "hidden"
                    } relative w-14 h-7 p-1 rounded-full before:absolute before:bg-white before:w-5 before:h-5 before:p-1 before:rounded-full before:duration-500 before:left-1 peer-checked:before:left-8 peer-checked:before:bg-white ${
                      isMuted
                        ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)]"
                        : "bg-[#E5E7EB]"
                    }`}
                  ></div>
                </label>
              </div>
            </div>

            <div className="flex justify-between items-center pt-2.5">
              <div>
                <p className=" flex items-center gap-2 text-black font-semibold">
                  <CiGlobe className="text-xl" />{" "}
                  {activeChannel?.isPublic ? "Public" : "Private"} Channel
                </p>
              </div>

              {isAdmin && (
                <BsPencil
                  onClick={() => setShowEditChannel(true)} // 👈 Show Edit Channel Component
                  className="cursor-pointer transform text-[var(--primary-color)]"
                />
              )}
            </div>

            {/* <div className="flex justify-between items-center pt-2">
              <p className=" flex items-center gap-2 text-black font-semibold">
                <IoColorPaletteOutline className="text-xl" />
                Custom Chat Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={chatColor}
                  onChange={(e) => {
                    setChatColor(e.target.value);
                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(e.target.value, bgColor, isMuted);
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-0 bg-transparent"
                />
              </div>
            </div>

            <div className="flex justify-between items-center pt-1">
              <p className="flex items-center gap-2 text-black font-semibold">
                <RiImageEditLine className="text-xl" />
                Custom Background Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={bgColor}
                  onChange={(e) => {
                    setBgColor(e.target.value);

                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(
                          chatColor,
                          e.target.value,
                          isMuted
                        );
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-none bg-transparent"
                />
              </div>
            </div> */}
          </div>

          {isAdmin && (
            <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4 space-y-5">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                {activeChannel?.users?.length} Follower
                {activeChannel?.users?.length > 1 && "s"}
              </h3>
              <div className="flex items-center gap-2">
                <button
                  className="flex gap-3 items-center justify-center rounded-full"
                  onClick={() => toggleAddGroupMember(true)}
                >
                  <div className="bg-[#F9F7FF] rounded-full w-12 h-12 flex items-center justify-center">
                    <RiUserAddLine className="text-xl text-[var(--primary-color)]" />
                  </div>
                  <span className="font-semibold text-black">
                    Add Followers
                  </span>
                </button>
              </div>

              {activeChannel?.users &&
                activeChannel?.users?.length > 0 &&
                sortUsers.map((user, index) => (
                  <div
                    key={user._id}
                    className="flex justify-between items-center space-x-2"
                  >
                    <div className="flex items-center gap-2 w-[80%]">
                      <div className="min-w-12 min-h-12 max-w-12 max-h-12 rounded-full">
                        <img
                          src={
                            user?.userImage ||
                            user?.avtarImage ||
                            profile_ImgUser
                          }
                          alt="c"
                          className={`${
                            user?.userImage || user?.avtarImage
                              ? "max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover object-center"
                              : "object-cover w-11 h-11 p-1 rounded-full"
                          }`}
                        />
                      </div>
                      <div className="flex-grow-1 w-full">
                        <div className="flex items-center justify-between">
                          <p className="text-black font-semibold text-[15px]">
                            {user?.name}
                          </p>
                          {activeChannel?.adminId?.some(
                            (ele) => ele._id == user._id
                          ) && (
                            <span className="bg-[#06B300] text-white text-xs px-2 py-1 rounded-full">
                              Admin
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-gray-500 pt-1 truncate">
                          {user?.about}
                        </p>
                      </div>
                    </div>

                    {user._id != uid && (
                      <Menu as="div" className="relative block text-left">
                        <Menu.Button className="text-black text-xl cursor-pointer z-10 relative focus:outline-none">
                          <PiCaretDownLight />
                        </Menu.Button>

                        <Menu.Items className="absolute right-0 w-max bg-white shadow-[0px_0px_100px_0px_#00000033] rounded-md text-sm z-50 focus:outline-none">
                          <div className="py-1 relative z-50">
                            <Menu.Item>
                              {({ active }) => (
                                <div
                                  onClick={() => createChat(user._id)}
                                  className={`p-3 cursor-pointer ${
                                    active ? "bg-gray-100" : ""
                                  }`}
                                >
                                  Message {user.name}
                                </div>
                              )}
                            </Menu.Item>

                            {isAdmin && (
                              <Menu.Item>
                                {({ active }) => (
                                  <div
                                    onClick={() => {
                                      setSelectedUser(user);
                                      setRemoveModal(true);
                                    }}
                                    className={`p-3 text-red-500 cursor-pointer ${
                                      active ? "bg-gray-100" : ""
                                    }`}
                                  >
                                    Remove {user.name}
                                  </div>
                                )}
                              </Menu.Item>
                            )}
                          </div>
                        </Menu.Items>
                      </Menu>
                    )}
                  </div>
                ))}
            </div>
          )}
          {isAdmin && (
            <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4 space-y-5">
              <div className="flex justify-between items-center">
                <div
                  onClick={() => setDeleteModal(true)}
                  className="cursor-pointer"
                >
                  <p className="text-[15px] flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55">
                    <GoTrash className="text-xl text-[#F44336]" />
                    Delete Channel
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={deleteChannel}
        description="Are you sure you want to delete the channel?"
        title="Delete Channel"
      />

      <Modal
        isOpen={removeModal}
        onClose={() => setRemoveModal(false)}
        onConfirm={removeUser}
        description="Are you sure you want to remove this user?"
        title="Remove user"
      />

      <Modal
        isOpen={isfollowLoading}
        onClose={() => setIsFollowLoading(false)}
        onConfirm={toggleFollowing}
        description={`Are you sure you want to ${
          isFollowing ? "unfollow" : "follow"
        } this channel?`}
        title={`${isFollowing ? "Unfollow" : "Follow"} channel`}
      />
    </>
  );
}
